import React, { memo } from "react";
import colors from "app/colors";
import { ForwardIcon } from "modules/icons";
import CircularIconButton from "../_shared/buttons/circular-icon-button";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import {
  FILE_GALLERY_BUTTON_BOX_SIZE,
  FILE_GALLERY_BUTTON_BACKGROUND_COLOR,
  FILE_GALLERY_BUTTON_WIDTH,
} from "modules/utils/Constants";
import { VStack, Text } from "@chakra-ui/react";
import useForwardMessage from "modules/hooks/use-forward-message";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
}

const FileGalleryForwardButton = ({ messageThread, message }: IProps) => {
  const { createLinkedThread } = useForwardMessage({
    messageThread,
    message,
  });

  return (
    <VStack spacing={1} w={FILE_GALLERY_BUTTON_WIDTH}>
      <CircularIconButton
        icon={
          <ForwardIcon
            fill={colors.white}
            boxSize={FILE_GALLERY_BUTTON_BOX_SIZE}
          />
        }
        onClick={createLinkedThread}
        aria-label="forward message"
        backgroundColor={FILE_GALLERY_BUTTON_BACKGROUND_COLOR}
        variant="hover"
      />
      <Text color={colors.grayPrimary} fontWeight={500} fontSize={10}>
        Forward
      </Text>
    </VStack>
  );
};

export default memo(FileGalleryForwardButton);
